export default __webpack_public_path__ + "static/Author-b4cebc93ce6c9f5fe0a660d0c1d5625a.png";